import { render, staticRenderFns } from "./HotKeyWord.vue?vue&type=template&id=f5004d9a&scoped=true"
import script from "./HotKeyWord.vue?vue&type=script&lang=js"
export * from "./HotKeyWord.vue?vue&type=script&lang=js"
import style0 from "./HotKeyWord.vue?vue&type=style&index=0&id=f5004d9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5004d9a",
  null
  
)

export default component.exports